export interface IPrefilledStatus {
  status: string;
  opportunityId?: string;
}

export class PrefilledStatus {
  public status: string;
  public opportunityId?: string;

  constructor(data: IPrefilledStatus) {
    this.status = data.status;
    this.opportunityId = data.opportunityId;
  }
}
